var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 15C18.8086 12.8966 17.1034 11.1914 15 11.1914C12.8966 11.1914 11.1914 12.8966 11.1914 15C11.1914 17.1034 12.8966 18.8086 15 18.8086C17.1034 18.8086 18.8086 17.1034 18.8086 15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 3.80859C18.8086 1.70517 17.1034 0 15 0C12.8966 0 11.1914 1.70517 11.1914 3.80859C11.1914 5.91202 12.8966 7.61719 15 7.61719C17.1034 7.61719 18.8086 5.91202 18.8086 3.80859Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 26.1914C18.8086 24.088 17.1034 22.3828 15 22.3828C12.8966 22.3828 11.1914 24.088 11.1914 26.1914C11.1914 28.2948 12.8966 30 15 30C17.1034 30 18.8086 28.2948 18.8086 26.1914Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDots);
export default __webpack_public_path__ + "static/media/icon-dots.e386733a81b409e41809c810a5bf0c1e.svg";
export { ForwardRef as ReactComponent };